import { useState } from 'react';
import type { CSSProperties, ReactNode } from 'react';

export interface CardProps {
  children: ReactNode;
  compact?: boolean;
  interactive?: boolean;
  onClick?: () => void;
  accent?: string;
  style?: CSSProperties;
  title?: string;
}

export function Card({ children, compact, interactive, onClick, accent, style, title }: CardProps) {
  const [hover, setHover] = useState(false);
  return (
    <div
      title={title}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={
        onClick
          ? (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClick();
              }
            }
          : undefined
      }
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        background: 'var(--panel)',
        border: `1px solid ${accent ?? (interactive && hover ? 'var(--border-strong)' : 'var(--border)')}`,
        borderRadius: 'var(--r-xl)',
        padding: compact ? 16 : 20,
        boxShadow: interactive && hover ? 'var(--shadow-1)' : 'none',
        transform: interactive && hover ? 'translateY(-1px)' : undefined,
        transition: 'transform var(--dur-1), box-shadow var(--dur-1), border-color var(--dur-1)',
        cursor: onClick ? 'pointer' : undefined,
        ...style,
      }}
    >
      {children}
    </div>
  );
}

export function CardHeader({ title, right }: { title: string; right?: ReactNode }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
      <h3 className="t-h3" style={{ flex: 1 }}>
        {title}
      </h3>
      {right}
    </div>
  );
}
